import { compact } from 'lodash-es'
import { AppThunk } from 'utils/redux'
import { DealActions } from 'api'
import { SelectionActions } from 'store/selection'
import {
  dealIdForRelatedDealTradesSelector,
  dealIdForRelatedMidTradeIncomingTradesSelector,
  dealIdForRelatedMidTradeInitiatedTradesSelector,
  dealIdForRelatedOpenRepoTradesSelector,
  dealIdForRelatedStructuredTradesSelector
} from 'selectors/selectionSelectors'

const updateMteInitiatedRelatedDealsSubscription = (dealId: string | null): AppThunk => dispatch => {
  dispatch(SelectionActions.setDealIdForRelatedMidTradeEventInitiated(dealId))
  dispatch(updateRelatedSubscription())
}

const updateMteIncomingRelatedDealsSubscription = (dealId: string | null): AppThunk => dispatch => {
  dispatch(SelectionActions.setDealIdForRelatedMidTradeEventIncoming(dealId))
  dispatch(updateRelatedSubscription())
}

const updateStructuredRelatedDealsSubscription = (dealId: string | null): AppThunk => dispatch => {
  dispatch(SelectionActions.setDealIdForRelatedStructuredTrades(dealId))
  dispatch(updateRelatedSubscription())
}

const updateOpenRepoRelatedDealsSubscription = (dealId: string | null): AppThunk => dispatch => {
  dispatch(SelectionActions.setDealIdForRelatedOpenRepoTrades(dealId))
  dispatch(updateRelatedSubscription())
}

const updateRelatedDealsSubscription = (dealId: string | null): AppThunk => dispatch => {
  dispatch(SelectionActions.setDealIdForRelatedDealTrades(dealId))
  dispatch(updateRelatedSubscription())
}

const updateRelatedSubscription = (): AppThunk => (dispatch, getState) => {
  const state = getState()

  const relatedDealIds = compact([
    dealIdForRelatedDealTradesSelector(state),
    dealIdForRelatedOpenRepoTradesSelector(state),
    dealIdForRelatedStructuredTradesSelector(state),
    dealIdForRelatedMidTradeInitiatedTradesSelector(state),
    dealIdForRelatedMidTradeIncomingTradesSelector(state)
  ])

  if (relatedDealIds.length === 0) {
    dispatch(DealActions.relatedUnsubscribeAll())
    dispatch(DealActions.interestPeriodUnsubscribeAll())
  } else {
    dispatch(DealActions.relatedSubscribe(relatedDealIds))
    dispatch(DealActions.interestPeriodSubscribe(relatedDealIds))
  }
}

export const RelatedDealsThunks = {
  updateMteIncomingRelatedDealsSubscription,
  updateMteInitiatedRelatedDealsSubscription,
  updateOpenRepoRelatedDealsSubscription,
  updateRelatedDealsSubscription,
  updateStructuredRelatedDealsSubscription
}
